export default __webpack_public_path__ + "static/media/china.920163b0.svg";